import { Form, Input, InputNumber, Select, Row, Col } from 'antd';
import { useEffect, useRef, useState } from 'react'
import fetchApi from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import system from "../../../config/systematic";
import WebSetMealIngredientFormList from '../../generalComponents/WebSetMealIngredientFormList';

const { Option } = Select;

export default function SetMealIngredientEdit(props: any) {

    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);

    /**计算毛利率 */
    const setPersent = (form: any, e: any) => {
        let grossProfitRatio: any = (e - form.getFieldValue("costPrices")) / e * 100;
        form.setFieldsValue({ grossProfitRatio: grossProfitRatio.toFixed(2) });
    }

    /** 基础数据*/
    const [ingredientBaseData, setIngredientBaseData] = useState<any>(data.type === "EDIT" ? true : false);

    /** 主配料数据 */
    // const [ingredientData, setIngredientData] = useState<any>([]);

    /** 门店菜式规格数据 */
    const [branchStoreMenuWarehouseSpecData, setBranchStoreMenuWarehouseSpecData] = useState<any>();

    /** 规格的状态 */
    const [disable, setDisable] = useState<any>(false);

    /** 成本预警峰值的状态 */
    const [isManager, setIsManager] = useState<any>(false);

    /** 成本预警峰值最低值 */
    const [minWarningData, setMinWarningData] = useState<any>(0);

    /** 成本预警峰值最高值 */
    const [maxWarningData, setMaxWarningData] = useState<any>(100);


    /** 合并数据 */
    const [ingredientDetailData, setIngredientDetailData] = useState<any>([]);

    const [tempDeleteData, setTempDeleteData] = useState<any>();

    const [formList, setFormList] = useState<any>({ form, type: data.type, ref, setIngredientDetailData, setTempDeleteData, setPersent })

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };

    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    /** 后端数据Service */
    let wmService = system.wmService;

    const getListDisabled = (rows: any, itemName: string) => {
        // console.log(rows);
        if (typeof rows !== "undefined") {
            if (rows.constructor === Object) {
                rows = [rows]
            } else {
                rows = rows
            }
            if (rows.length === undefined) { return undefined }

            return (rows.map((item: any, key: number) => {
                return <Option
                    value={item.id}
                    key={key}
                    obj={{ menuWarehouseSpecId: item.menuWarehouseSpecId, price: item.price, branchStoreMenuWarehouseSpecName: item.branchStoreMenuWarehouseSpecName }}
                    disabled={inArray(item.id, item.menuWarehouseIngredients)}
                >
                    {<span style={{ color: 'yellow' }}>{item[itemName]} </span>} {(form.getFieldsValue()['sellPrice'] !== undefined && form.getFieldsValue()['sellPrice'] !== item.price) ? <span style={{ color: 'green' }}>（ 现门店设置售价为 {item.price} ）</span> : ''}
                    {/* {item[itemName]} {(form.getFieldsValue()['sellPrice'] !== undefined && form.getFieldsValue()['sellPrice'] !== item.price) ? <span style={{ color: 'yellow' }}>（ 现门店设置售价为 {item.price} ）</span> : ''} */}
                </Option>
            }))
        }
    };

    //查询该规格是否在已设置主配料
    const inArray = (search: any, array: any) => {
        // console.log("-----------------------------------------");
        for (var i in array) {
            // console.log("inarray 里面循环第 " + i + " 次")
            // console.log("数据库里面的数据 " + array[i])
            // console.log("现在提交的数据是 " + search)
            if (array[i].branchStoreMenuWarehouseSpecId === search) {
                return true;
            }
        }
        // console.log("-----------------------------------------")
        return false;
    }

    //选择规格后，把菜品智库规格填入
    const selectSpec = async (e: any, option: any, form?: any) => {
        form.setFieldsValue({ menuWarehouseSpecId: option.obj.menuWarehouseSpecId });
        form.setFieldsValue({ sellPrice: option.obj.price });
        form.setFieldsValue({ branchStoreMenuWarehouseSpecName: option.obj.branchStoreMenuWarehouseSpecName });

        // form.setFieldsValue({ branchStoreMenuWarehouseSpecName: option.children[0] });

        setPersent(form, option.obj.price);
    }

    const updateWarning = async (e: any) => {
        form.setFieldsValue({ minWarning: Number(e) - 5 < 0.01 ? 0.01 : Number(e) - 5 });
        form.setFieldsValue({ maxWarning: Number(e) + 5 > 99.99 ? 99.99 : Number(e) + 5 });
    }

    const checkWaring = async (key: string, e: any) => {
        switch (key) {
            case 'minWarning':
                setMinWarningData(e);
                break;
            case 'maxWarning':
                setMaxWarningData(e);
                break;
        }
    }

    /**数据 */
    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
            ref.current.row.then(async (res: any) => {
                if (typeof res === 'undefined') { return }
                if (res.success === true) {
                    if (data.type === "EDIT") {
                        form.setFieldsValue({ branchStoreMenuWarehouseSpecName: res.data.branchStoreMenuWarehouseSpec.branchStoreMenuWarehouseSpecName });
                        setMinWarningData(res.data.minWarning);
                        setMaxWarningData(res.data.maxWarning);
                    }


                    // let new_arr = [];
                    // let str_arr: any = [];

                    // /** 点击编辑后，根据数据的内容来进行分析，筛选出之前有数据的口味 */
                    // for (var i_data = 0, len_data = res.data.length; i_data < len_data; i_data++) {
                    //     let str_data = "ingredient" + i_data;
                    //     form.setFieldsValue({ [str_data]: i_data });

                    //     if (res.data[i_data].length === 0) {
                    //         str_arr.push(i_data);
                    //     }
                    //     else {
                    //         str_arr.push(999);
                    //     }
                    // }

                    // await fetchApi.GET(wmService, {
                    //     apiId: 'generalData',
                    //     apiVariable: 'ingredient',
                    //     apiExtend: 'showList'
                    //     // eslint-disable-next-line no-loop-func
                    // }).then(ress => {

                    //     new_arr = ress.data.map((item: any) => ({
                    //         id: item.id,                      //设置字段，在form.list下的form.item中指定的字段值
                    //         name: item.name,
                    //         visible: str_arr[item.id] === item.id ? false : item.visible
                    //     }));
                    //     setIngredientData(new_arr);
                    // });
                }
            })
        }

        const fetchData = async () => {

            form.setFieldsValue({ foodName: data.sendPageData.foodName });
            form.setFieldsValue({ branchStoreMenuWarehouseId: data.sendPageData.branchStoreMenuWarehouseId });
            form.setFieldsValue({ branchStoreId: data.sendPageData.branchStoreId });
            form.setFieldsValue({ foodType: data.sendPageData.foodType });
            form.setFieldsValue({ menuWarehouseId: data.sendPageData.menuWarehouseId });

            if (data.type !== 'NEW') {
                setDisable(true);
            }

            // fetchApi.GET(wmService, {
            //     apiId: 'generalData',
            //     apiVariable: 'ingredient',
            //     apiExtend: 'showList'
            // }).then(res => {
            //     //console.log(res.data);
            //     setIngredientData(res.data);
            //     let ingredient_arr = [];
            //     for (var ingredientid = 0, ingredientlen = res.data.length; ingredientid < ingredientlen; ingredientid++) {
            //         ingredient_arr.push([]);
            //     }
            //     // console.log(ingredient_arr);
            //     // setBaseData(ingredient_arr);
            //     // setFinalData(ingredient_arr);

            //     for (var i = 0, len = res.data.length; i < len; i++) {
            //         let str_data = "ingredient" + res.data[i].id;
            //         //let filedStr_data = "ingredientDetail" + res.data[i].id;
            //         form.setFieldsValue({ [str_data]: res.data[i].id });
            //         //form.setFieldsValue({ [filedStr_data]: '' });
            //     }
            // });

            fetchApi.GET(wmService, {
                apiId: 'branchStoreMenuWarehouseSpec',
                apiExtend: 'checkBranchStoreMenuWarehouseSpec',
                branchStoreMenuWarehouseId: data.sendPageData.branchStoreMenuWarehouseId,
            }).then(res => {
                if (res.success) {
                    setBranchStoreMenuWarehouseSpecData(res.data);
                    if (res.data.length === 1) {
                        form.setFieldsValue({ branchStoreMenuWarehouseSpecId: res.data[0].id });
                        form.setFieldsValue({ sellPrice: res.data[0].price });

                        form.setFieldsValue({ branchStoreMenuWarehouseSpecName: res.data[0].branchStoreMenuWarehouseSpecName });
                    }
                }
            });

            fetchApi.GET(wmService, {
                apiId: "menuWarehouseIngredient",
                apiExtend: 'checkManager'
            }).then(res => {
                setIsManager(res.data);
            });
        }
        fetchData()
    }, [])

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'menuWarehouseIngredient',
        mountDataOptions: {
            userMount: {
                isBranchStore: true
            }
        }
    };

    const children = (isLoading: boolean) => {
        return <AntDraggableModal
            title={(data.type === 'NEW' ? '新增' : '编辑') + '套餐主配料'}
            open={true}
            okText='确定'
            cancelText='取消'
            // okButtonProps={{ disabled: loadingData }}
            onOk={handleOk}
            onCancel={handleCancel}
            closable={false}
            maskClosable={false}
            width={1150}
            confirmLoading={isLoading}
        >
            <Form
                form={form}
                name="Edit"
                onFinish={handleOk}
            >
                <Row gutter={[8, 0]}>
                    <Col span={24}>
                        <Form.Item
                            label="id"
                            name="id">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={0}>
                        <Form.Item
                            label="门店id"
                            name="branchStoreId">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={0}>
                        <Form.Item
                            label="菜式类型"
                            name="foodType">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={0}>
                        <Form.Item
                            label="门店菜式id"
                            name="branchStoreMenuWarehouseId">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="菜式名称"
                            name="foodName">
                            <Input style={{ color: 'yellow' }} disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="售价 (元)"
                            name="sellPrice"
                            rules={[{ required: true, message: '请输入售价!' }]}>
                            <InputNumber style={{ color: 'white', fontSize: '15px', backgroundColor: 'blue' }} min={0} onChange={(e) => setPersent(form, e)} disabled />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="规格"
                            name="branchStoreMenuWarehouseSpecId"
                            rules={[{
                                required: true,
                                message: '请输入规格!'
                            }]}>
                            <Select
                                disabled={disable}
                                showSearch
                                placeholder="规格"
                                onChange={(e, option) => selectSpec(e, option, form)}
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getListDisabled(branchStoreMenuWarehouseSpecData, 'branchStoreMenuWarehouseSpecName')}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={0}>
                        <Form.Item
                            label="菜式规格名称"
                            name="branchStoreMenuWarehouseSpecName">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="成本 (元)"
                            name="costPrices"
                            rules={[{ required: true, message: '请填写成本!' }]}>
                            <InputNumber style={{ color: 'white', fontSize: '15px', backgroundColor: 'blue' }} min={0} disabled />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="标准毛利率 (%)"
                            name="standardGrossProfitRatio"
                            rules={[{ required: true, message: '请填写标准毛利率!' }]}>
                            <InputNumber onChange={updateWarning} min={0.01} max={99.99} />
                        </Form.Item>
                    </Col>

                    <Col span={0}>
                        <Form.Item label="毛利预警范围 (%)" >
                            <Form.Item
                                name="minWarning"
                                style={{ display: 'inline-block' }}
                                rules={[{ required: true, message: '请输入毛利预警最低值!' }]}
                            >
                                <InputNumber disabled={data.type === 'EDIT' ? !isManager : false} min={0} max={maxWarningData} onChange={(e) => checkWaring("minWarning", e)} />
                            </Form.Item>
                            &nbsp;
                            ~
                            &nbsp;
                            <Form.Item
                                name="maxWarning"
                                style={{ display: 'inline-block' }}
                                rules={[{ required: true, message: '请输入毛利预警最高值!' }]}
                            >
                                <InputNumber disabled={data.type === 'EDIT' ? !isManager : false} min={minWarningData} max={100} onChange={(e) => checkWaring("maxWarning", e)} />
                            </Form.Item>
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="毛利率 (%)"
                            name="grossProfitRatio"
                            rules={[{ required: true, message: '请填写毛利率!' }]}>
                            <InputNumber style={{ color: 'white', fontSize: '15px', backgroundColor: 'blue' }} min={0.01} max={99.99} disabled />
                        </Form.Item>
                    </Col>
                </Row>

                <br></br>

                <Row gutter={[8, 0]}>
                    <Col span={2}> </Col>
                    <Col span={4}>菜式</Col>
                    <Col span={2}>规格</Col>
                    <Col span={2}>定量</Col>
                    <Col span={2}>起率&nbsp;(%)</Col>
                    <Col span={2}>&nbsp;&nbsp;&nbsp;&nbsp;单价</Col>
                    <Col span={2}>&nbsp;&nbsp;&nbsp;&nbsp;金额</Col>
                    <Col span={4}>&nbsp;&nbsp;&nbsp;自动更新</Col>
                    <Col span={2}>&nbsp;&nbsp;备注</Col>

                    <Col span={24}>
                        <Row gutter={[8, 0]}>
                            <Col span={24}>
                                <Form.Item
                                    name={"setMealDetail"}
                                >
                                    <Input style={{ color: 'yellow' }} disabled={true} defaultValue={'套餐菜式'} />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <WebSetMealIngredientFormList props={formList} formName={'setMealDetails'} branchStoreId={data.sendPageData.branchStoreId} isBase={ingredientBaseData} tempDeleteData={tempDeleteData} ></WebSetMealIngredientFormList>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Form>
        </AntDraggableModal>
    }

    return (
        <>
            <WebEditUniversal ref={ref} props={extendProps} children={children} totalData={ingredientDetailData} />
        </>
    )
}

